import React from 'react';

const ServiceSchemaFormModal = React.lazy(() => import('../components/FormModal'));
const serviceSchemaModalRegistry = {
    console_serviceSchemaId: ServiceSchemaFormModal
};
export default serviceSchemaModalRegistry;
